import {NotificationsService} from '../../libs/ui/src/index';

import {client} from '../apiService';

const _NotificationsService = new NotificationsService({client});
export {_NotificationsService as NotificationsService};
